import { cloneDeep } from 'lodash';
import { config } from '@/scripts/tools/config';

// 加载 MTA js
let loaded = false;
const queue = [];
const mtaJsReady = fn => {
  queue.push(fn);
  if (window._mtac) return;
  window._mtac = { senseHash: 0 };
  const mta = document.createElement('script');
  mta.src = '//pingjs.qq.com/h5/stats.js?v2.0.4';
  mta.setAttribute('name', 'MTAH5');
  mta.setAttribute('sid', '500617479');
  mta.setAttribute('cid', '500619134');
  const s = document.getElementsByTagName('script')[0];
  mta.onload = () => {
    loaded = true;
    while (queue.length) {
      queue.shift()();
    }
  };
  s.parentNode.insertBefore(mta, s);
};

// 转换方法，MTA js 加载完才执行调用
const getFn = name => (...rest) => {
  const run = () => {
    if (window.MtaH5) {
      window.MtaH5[name](...rest);
    }
  };
  if (loaded) {
    run();
  } else {
    mtaJsReady(run);
  }
};

// 对外暴露的方法
const clickStat = getFn('clickStat');
const mta = {
  clickStat(eventName, params) {
    params = cloneDeep(params) || {};
    params.version = config.version;
    params.platform = config.platform;
    clickStat(eventName, params);
  },
};

export default mta;
